import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { AnimatePresence, motion } from "framer-motion";
import { setSessionData, getSessionData } from "../../cache";
import CryptoJS from "crypto-js";

function Login({
  setClass9foroute,
  class9foroute,
  setClass10foroute,
  class10foroute,
}) {
  const [className, setClassName] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [schoolPass, setSchoolPass] = useState("");

  const [loading, setLoading] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isOtpVerifying, setIsOtpVerifying] = useState(false);

  const [loginOtp, setLoginOtp] = useState("");
  const [defaultOtp, setDefaultOtp] = useState("");

  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");

  const otp1Ref = useRef(null);
  const otp2Ref = useRef(null);
  const otp3Ref = useRef(null);
  const otp4Ref = useRef(null);
  const otp5Ref = useRef(null);
  const otp6Ref = useRef(null);

  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const secondaryFOProtectedRoutes = ["/secondary-accounts"];

  const [selectedConfig, setSelectedConfig] = useState(
    getSessionData("setconfig") || ""
  );

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  const fetchConfigData = async () => {
    let baseUrl = "";
    if (selectedConfig === "CLASS_9") {
      baseUrl = config.API_BASE_URL;
    } else if (selectedConfig === "CLASS_10") {
      baseUrl = config.API_BASE_URL2;
    } else {
      baseUrl = "";
    }
    if (!baseUrl) return;

    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(`${baseUrl}/FetchConfigurationData`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
      });

      const data = await response.json();
      if (response.ok) {
        const configData = data?.data;
        sessionStorage.setItem("class9foActive", configData.cL_9_FO_PORTAL);
        sessionStorage.setItem("class10foActive", configData.cL_10_FO_PORTAL);
        setClass9foroute(configData.cL_9_FO_PORTAL);
        setClass10foroute(configData.cL_10_FO_PORTAL);
      } else {
        Swal.fire("Error", data.message || "Invalid response", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
    }
  };
  useEffect(() => {
    generateCaptcha();
  }, []);
  useEffect(() => {
    fetchConfigData();
    // generateCaptcha();
  }, [selectedConfig]);

  /* useEffect(() => {
    if (class9foroute) {
      const currentPath = location.pathname;
      if (
        secondaryFOProtectedRoutes.includes(currentPath) &&
        class9foroute?.toUpperCase() !== "ON"
      ) {
        navigate("/no-access");
      }
    }
    if (class10foroute) {
      const currentPath = location.pathname;
      if (
        secondaryFOProtectedRoutes.includes(currentPath) &&
        class10foroute?.toUpperCase() !== "ON"
      ) {
        navigate("/no-access");
      }
    }
  }, [class9foroute, class10foroute, location.pathname]); */

  // time use effect
  useEffect(() => {
    let interval;
    if (resendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
      setLoginOtp("");
      // sessionStorage.setItem("LoginOtp", "");
    }
    return () => clearInterval(interval);
  }, [resendDisabled, timer]);
  // Generate Smart Math Captcha
  const generateCaptcha = () => {
    const operations = ["+", "-", "*"];
    let num1 = Math.floor(Math.random() * 10); //+ 10;
    let num2 = Math.floor(Math.random() * 10); //+ 10;
    const op = operations[Math.floor(Math.random() * operations.length)];

    if (op === "-" && num1 < num2) {
      [num1, num2] = [num2, num1];
    }

    let answer;
    switch (op) {
      case "+":
        answer = num1 + num2;
        break;
      case "-":
        answer = num1 - num2;
        break;
      case "*":
        answer = num1 * num2;
        break;
    }
    const question = `${num1} ${op} ${num2} = ?`;
    setCaptchaQuestion(question);
    setCaptcha(answer);
    setUserCaptcha("");
    setIsCaptchaValid(false);
    drawCaptcha(question);
  };
  // Draw CAPTCHA on Canvas
  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Add noise
    for (let i = 0; i < 100; i++) {
      ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        1
      );
    }

    // Captcha text
    ctx.font = "italic bold 28px 'Courier New', monospace";
    ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${
      Math.random() * 100
    })`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  };
  // Captcha input handler
  const validateCaptcha = (e) => {
    const val = e.target.value;
    setUserCaptcha(val);
    setIsCaptchaValid(parseInt(val) === parseInt(captcha));
  };
  const handleLoginWithCaptcha = async () => {
    if (!className) {
      Swal.fire("Warning", "Please Choose Class.", "warning");
      return;
    }
    if (!schoolCode) {
      Swal.fire("Warning", "Please Choose Accounts ID.", "warning");
      return;
    }
    if (!schoolPass) {
      Swal.fire("Warning", "Please enter password.", "warning");
      return;
    }
    if (!isCaptchaValid) {
      Swal.fire({
        icon: "error",
        title: "Invalid CAPTCHA",
        text: "Please enter the correct CAPTCHA.",
        confirmButtonColor: "#d33",
      });
      generateCaptcha();
      return;
    }
    if (class9foroute !== "ON" && className === "CLASS_9") {
      Swal.fire(
        "Warning",
        "Class 9 FO Portal is currently disabled.",
        "warning"
      );
      return;
    }
    if (class10foroute !== "ON" && className === "CLASS_10") {
      Swal.fire(
        "Warning",
        "Class 10 FO Portal is currently disabled.",
        "warning"
      );
      return;
    }
    await handleLogin();
    generateCaptcha();
  };
  // Login API call
  const handleLogin = async () => {
    setLoading(true);
    try {
      const tokeng = generateOneTimeToken();
      // Choose API endpoint based on class
      const ApiEndPoint =
        className === "CLASS_9"
          ? "FOAuthenticationSecondary"
          : className === "CLASS_10"
          ? "FOAuthenticationSecondary_CL10"
          : "";
      let baseUrl = "";
      if (selectedConfig === "CLASS_9") {
        baseUrl = config.API_BASE_URL;
      } else if (selectedConfig === "CLASS_10") {
        baseUrl = config.API_BASE_URL2;
      } else {
        baseUrl = "";
      }
      if (!baseUrl) return;
      // Use the variable in the URL
      const response = await fetch(`${baseUrl}/${ApiEndPoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: JSON.stringify({
          loginid: schoolCode,
          password: schoolPass,
          class: className,
        }),
      });

      const data = await response.json();
      // console.log("Login response:", data);
      if (response.ok) {
        sessionStorage.setItem("schoolCode", data.data.schooL_CODE);
        sessionStorage.setItem("className", data.data.class);
        setDefaultOtp(data.data.fO_DEFAULT_OTP);
        handleSentOtp(data.data.fO_DEFAULT_OTP);
        sessionStorage.setItem("secondaryAccTokenWithOutOtp", data.data.token);
        /* sessionStorage.setItem("secondaryaccountstoken", data.data.token);
        navigate("/secondary-accounts-dashboard-class-ix"); */
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSentOtp = (otpValue) => {
    const schoolCode = sessionStorage.getItem("schoolCode");
    const conOtp = `${schoolCode}|${otpValue}`;
    setLoginOtp(conOtp);
    setOtp1("");
    setOtp2("");
    setOtp3("");
    setOtp4("");
    setOtp5("");
    setOtp6("");
    setShowOtpModal(true);
    setResendDisabled(true);
    otp1Ref.current?.focus();
    setTimer(180);
  };
  // otp input function
  const handleOtpInput = (e, setPart, maxLength, nextRef) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, maxLength);
    setPart(value);
    if (value.length === maxLength && nextRef?.current) {
      nextRef.current.focus();
    }
  };
  // otp remove function
  const handleOtpBackspace = (e, value, prevRef) => {
    if (e.key === "Backspace" && value === "" && prevRef?.current) {
      prevRef.current.focus();
    }
  };
  // otp verify function
  const handleOtpVerify = () => {
    setIsOtpVerifying(true);
    const otp = [otp1, otp2, otp3, otp4, otp5, otp6].join("");
    let LoginOtp = loginOtp;
    let schoolCode = sessionStorage.getItem("schoolCode");
    let secondaryAccTokenWithOutOtp = sessionStorage.getItem(
      "secondaryAccTokenWithOutOtp"
    );
    console.log("Login OTP:", LoginOtp);
    console.log("School Code:", schoolCode);
    if (LoginOtp !== null && LoginOtp !== "") {
      let [extractedschoolCode, extractedOtp] = LoginOtp.split("|");

      if (otp.length !== 6) {
        Swal.fire(
          "Warning",
          "Please enter all 6 digits of the OTP.",
          "warning"
        );
        setIsOtpVerifying(false);
        return;
      }

      if (schoolCode === extractedschoolCode && otp === extractedOtp) {
        sessionStorage.setItem(
          "secondaryaccountstoken",
          secondaryAccTokenWithOutOtp
        );
        sessionStorage.removeItem("secondaryAccTokenWithOutOtp");
        setLoginOtp("");
        setDefaultOtp("");
        if (className === "CLASS_9") {
          navigate("/secondary-accounts-dashboard-class-ix");
        } else if (className === "CLASS_10") {
          navigate("/secondary-accounts-dashboard-class-x");
        } else {
          return;
        }
      } else {
        Swal.fire("Error", "Invalid OTP. Please try again.", "error");
        setIsOtpVerifying(false);
        return;
      }
    } else {
      Swal.fire("Error", "Invalid OTP. Please try again.", "error");
      setIsOtpVerifying(false);
      return;
    }
  };
  // otp model colse funtion
  const handlemodalclose = () => {
    setLoginOtp("");
    setDefaultOtp("");
    // Clear OTP fields
    setOtp1("");
    setOtp2("");
    setOtp3("");
    setOtp4("");
    setOtp5("");
    setOtp6("");
    setShowOtpModal(false);
    setIsOtpVerifying(false);
    setResendDisabled(false);
    sessionStorage.removeItem("schoolCode");
    sessionStorage.removeItem("className");
    sessionStorage.removeItem("secondaryAccTokenWithOutOtp");
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0 login-bg">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-4 px-3 px-sm-4">
                <div className="brand-logo" style={{ display: "flex" }}>
                  <img
                    src="../assets/images/jac.png"
                    alt="logo"
                    style={{ height: 50, width: 50, marginRight: 10 }}
                  />
                  <p
                    className="font-weight-light"
                    style={{
                      margin: "auto",
                      textAlign: "center",
                      fontSize: 19,
                      fontWeight: 600,
                    }}
                  >
                    Jharkhand Academic Council Ranchi
                  </p>
                </div>
                <h3 className="text-center">Secondary Accounts Portal</h3>
                <form
                  className="pt-2"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleLoginWithCaptcha();
                  }}
                >
                  <div className="form-group">
                    <h6 className="font-weight-light">Select Class</h6>
                    <select
                      className="form-select form-select-xs"
                      value={className}
                      onChange={(e) => {
                        setClassName(e.target.value);
                        setSessionData("setconfig", e.target.value);
                        setSelectedConfig(e.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      <option value="CLASS_9">Class IX</option>
                      <option value="CLASS_10">Class X</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <h6 className="font-weight-light">Enter Accounts ID</h6>
                    <input
                      type="text"
                      className="form-control form-control-xs"
                      placeholder="Enter Accounts ID"
                      value={schoolCode}
                      onChange={(e) => setSchoolCode(e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <h6 className="font-weight-light">Enter Password</h6>
                    <input
                      type="password"
                      className="form-control form-control-xs"
                      placeholder="Enter Password"
                      value={schoolPass}
                      onChange={(e) => setSchoolPass(e.target.value)}
                    />
                  </div>

                  <div className="form-group mb-3 text-center">
                    <canvas
                      ref={canvasRef}
                      width="200"
                      height="40"
                      style={{ border: "1px solid #ddd" }}
                    />
                    <button
                      type="button"
                      onClick={generateCaptcha}
                      className="btn btn-secondary ms-2"
                      style={{ marginTop: "-33px" }}
                    >
                      ↻ Refresh
                    </button>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Enter CAPTCHA</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter CAPTCHA"
                      value={userCaptcha}
                      onChange={validateCaptcha}
                    />
                  </div>

                  <div className="mt-1">
                    <button
                      type="submit"
                      className="btn btn-block bg-brown btn-xs text-white"
                      style={{ padding: "10px" }}
                      disabled={loading}
                    >
                      {loading ? "Logging in..." : "Login"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Otp modal section */}
      <AnimatePresence>
        {showOtpModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                width: "95%",
                maxWidth: "500px",
                borderRadius: "12px",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleOtpVerify();
                }}
              >
                <div className="modal-header" style={{ padding: "10px" }}>
                  <h5 className="modal-title">OTP Verification</h5>
                  <button
                    type="button"
                    className="btn close"
                    aria-label="Close"
                    onClick={() => {
                      handlemodalclose();
                    }}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div
                  className="modal-body"
                  style={{ padding: "15px", border: "1px solid lightgray" }}
                >
                  <div className="row" style={{ padding: "0px 25px" }}>
                    {[
                      {
                        ref: otp1Ref,
                        value: otp1,
                        set: setOtp1,
                        next: otp2Ref,
                        prev: null,
                      },
                      {
                        ref: otp2Ref,
                        value: otp2,
                        set: setOtp2,
                        next: otp3Ref,
                        prev: otp1Ref,
                      },
                      {
                        ref: otp3Ref,
                        value: otp3,
                        set: setOtp3,
                        next: otp4Ref,
                        prev: otp2Ref,
                      },
                      {
                        ref: otp4Ref,
                        value: otp4,
                        set: setOtp4,
                        next: otp5Ref,
                        prev: otp3Ref,
                      },
                      {
                        ref: otp5Ref,
                        value: otp5,
                        set: setOtp5,
                        next: otp6Ref,
                        prev: otp4Ref,
                      },
                      {
                        ref: otp6Ref,
                        value: otp6,
                        set: setOtp6,
                        next: null,
                        prev: otp5Ref,
                      },
                    ].map((field, index) => (
                      <div
                        className="col-2"
                        key={index}
                        style={{ padding: "0px 10px" }}
                      >
                        <input
                          type="tel"
                          ref={field.ref}
                          value={field.value}
                          onChange={(e) =>
                            handleOtpInput(e, field.set, 1, field.next)
                          }
                          onKeyDown={(e) =>
                            handleOtpBackspace(e, field.value, field.prev)
                          }
                          className="form-control form-control-sm text-center number"
                          maxLength="1"
                          pattern="[0-9]*"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          autoFocus={index === 0}
                        />
                      </div>
                    ))}
                  </div>
                  <p
                    id="timer"
                    className="text-center text-danger"
                    style={{ margin: "5px 0px" }}
                  >
                    {resendDisabled
                      ? `Resend in ${timer} seconds`
                      : "You can resend OTP now"}
                  </p>
                </div>

                <div
                  className="modal-footer"
                  style={{ padding: "10px", display: "flex", gap: "5px" }}
                >
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => handleSentOtp(defaultOtp)}
                    disabled={resendDisabled}
                  >
                    <i className="fa fa-refresh"></i>&nbsp;Resend OTP
                  </button>

                  <button
                    type="submit"
                    className={`btn text-white ${
                      isOtpVerifying ? "bg-danger" : "bg-brown"
                    }`}
                    disabled={isOtpVerifying}
                  >
                    <i
                      className={`fa ${
                        isOtpVerifying ? "fa-refresh fa-spin" : "fa-check"
                      }`}
                    ></i>
                    &nbsp;
                    {isOtpVerifying ? "Verifying ..." : "Verify OTP"}
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Login;
